export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const TOGGLE_LANG = 'TOGGLE_LANG';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const USER_PROFILE_MISSING = 'USER_PROFILE_MISSING';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL';
export const AUTH_LOADING = 'AUTH_LOADING';
export const GENERAL_LOADING = 'GENERAL_LOADING';
export const AUTH_SWITCHING = 'AUTH_SWITCHING';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SWITCH_ERROR = 'SWITCH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const RESET_FAIL = 'RESET_FAIL';
export const RESET_SUCCESS = 'RESET_SUCCESS';

export const SWITCH_SUCCESS = 'SWITCH_SUCCESS';
export const SWITCH_FAIL = 'SWITCH_FAIL';
export const UPDATE_LANG = 'UPDATE_LANG';

export const LOGOUT = 'LOGOUT';
export const AUTH_CLEAR_ERRORS = 'AUTH_CLEAR_ERRORS';

/*----------*/
// payment
/*----------*/

export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_FAIL = 'PAYMENT_FAIL';
export const PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';
export const PAYMENT_CLEAR_ERRORS = 'PAYMENT_CLEAR_ERRORS';

/*----------*/
// site specific
/*----------*/
export const TOGGLE_NAV = 'TOGGLE_NAV';
export const TOGGLE_COUNTRYLIST = 'TOGGLE_COUNTRYLIST';
export const TOGGLE_CART = 'TOGGLE_CART';
export const TOGGLE_AUTH_MODAL = 'TOGGLE_AUTH_MODAL';
export const SET_AUTH_PAGE = 'SET_AUTH_PAGE';

/*----------*/
// startup
/*----------*/
export const GET_STARTUP_DATA = 'GET_STARTUP_DATA';
export const GET_IP_DATA = 'GET_IP_DATA';

/*----------*/
// filters
/*----------*/

export const SET_FILTER = 'SET_FILTER';

/*----------*/
// filters
/*----------*/
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const UPDATE_USER_BY_ID = 'UPDATE_USER_BY_ID';

/*----------*/
// Cart
/*----------*/
export const GET_CART = 'GET_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const ADD_VOUCHER_TO_CART = 'ADD_VOUCHER_TO_CART';
export const REMOVE_VOUCHER_FROM_CART = 'REMOVE_VOUCHER_FROM_CART';

/*----------*/
// purchases
/*----------*/
export const GET_PURCHASES = 'GET_PURCHASES';
export const GET_PURCHASE_IDS = 'GET_PURCHASE_IDS';
export const POST_PURCHASE = 'POST_PURCHASE';
export const POST_FATOORAH_INVOICE = 'POST_FATOORAH_INVOICE';
export const PAYMENT_URL = 'PAYMENT_URL';
export const POST_PURCHASE_BYPASS = 'POST_PURCHASE_BYPASS';
export const RESET_PURCHASES = 'RESET_PURCHASES';
export const SET_PURCHASEDIDS_FLAG = 'SET_PURCHASEDIDS_FLAG';

/*----------*/
// purchases
/*----------*/
export const ORDER_SUCCESSS = 'ORDER_SUCCESSS';
export const ORDER_THANKS_VIEWED = 'ORDER_THANKS_VIEWED';
